import { useMutation, useQuery } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const NotificationAlertContext = createContext(null);

type Props = {
  children: ReactElement;
};

const NotificationAlertProvider: FunctionComponent<Props> = ({ children }) => {
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["notification_alert"],
    queryFn: async () => {
      const {
        data: { data },
      } = await Api.get(`account/notifications`);

      return data;
    },
  });

  const {
    mutateAsync,
    data: notificationReadData,
    isPending,
    error,
  } = useMutation({
    mutationFn: async (payload) => {
      const data = await Api.post(
        `account/notifications/${payload}/markread`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      data,
      isLoading,
      isFetching,
      mutateAsync,
      notificationReadData,
      isPending,
      error,
    }),
    [
      data,
      isLoading,
      isFetching,
      mutateAsync,
      notificationReadData,
      isPending,
      error,
    ],
  );
  return (
    <NotificationAlertContext.Provider value={contextValue}>
      {children}
    </NotificationAlertContext.Provider>
  );
};

export default NotificationAlertProvider;
